/** Добавляет значение к отмеченным или убирает, если оно уже отмечено. Исходный набор не меняет. */
export const toggleValue = <T>(values: T[], value: T) =>
  values.includes(value) ? values.filter((selected) => selected !== value) : [...values, value]
